import { format, startOfMonth } from 'date-fns';
import { DATE_FORMAT_ISO } from '@/constants/date';
import { z } from 'zod';
const startDate = startOfMonth(new Date());
export const dateRangeSchema = z.object({
    from: z.string().default(format(startDate, DATE_FORMAT_ISO)),
    to: z.string().default(format(new Date(), DATE_FORMAT_ISO)),
});
